import React, { useEffect, useState } from "react"
import { FastField, useFormikContext } from "formik"
import ShareholderModal from "./ShareholderModal"
import Shareholder from "./Shareholder"
import Loader from "../../../Loader"

const Shareholders = () => {
  const { errors, touched } = useFormikContext()
  const [shareholders, setShareholders] = useState([])
  const [popup, setPopup] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const getShareholders = () => {
    fetch(
      `${
        process.env.DIY_BASE_URL
      }/api/order/v1/CompanyIncorporation/step2?order-ref=${localStorage.getItem(
        "orderReference"
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Token ${localStorage.getItem("dd_token")}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false)
        setShareholders(data)
      })
  }

  useEffect(() => {
    getShareholders()
  }, [])

  const hidePopup = () => {
    setPopup(false)
  }

  if (isLoading) return <Loader width="50" color="#46b839" />

  return (
    <>
      <div className="row">
        <div className="col text-right">
          <button
            className="btn cursor text-secure"
            onClick={() => setPopup(true)}
            type="button"
          >
            + Add New Shareholder
          </button>
        </div>
      </div>

      <div className="">
        {shareholders.map((shareholder, index) => (
          <Shareholder data={shareholder} key={index} />
        ))}
      </div>

      <ShareholderModal
        show={popup}
        closePopup={() => hidePopup()}
        fetchShareholders={getShareholders}
      />
    </>
  )
}
export default Shareholders
